import type { AssessmentResponse } from '~/api/types'
import { scaleLabel } from '~/components/assessment/labels'
import { CustomSelect } from '~/components/ui/custom-select'
import { Label } from '~/components/ui/label'

/** 좁은 화면에서 변경 입력 폼 안에 대상 평가 선택기를 표시한다. */
export function MobileAssessmentSelect({
    assessments,
    selectedId,
    selectedAssessment,
    onSelectAssessment,
}: {
    assessments: AssessmentResponse[]
    selectedId: string
    selectedAssessment?: AssessmentResponse
    onSelectAssessment: (value: string) => void
}) {
    return (
        <div className='hidden space-y-1.5 max-xl:block'>
            <Label htmlFor='mt-assessment'>대상 평가</Label>
            <CustomSelect
                id='mt-assessment'
                value={selectedId}
                onValueChange={onSelectAssessment}
                ariaLabel='대상 평가 선택'
                className='h-11 rounded-sm'
                options={assessments.map((item) => ({
                    value: item.id,
                    label: `${item.title} (${scaleLabel(item.scale)})`,
                }))}
            />
            {selectedAssessment ? (
                <p className='text-muted-foreground text-xs'>
                    {selectedAssessment.classification ?? '분류 미정'} ·{' '}
                    {scaleLabel(selectedAssessment.scale)} ·{' '}
                    {selectedAssessment.industry ?? '업종 미정'}
                </p>
            ) : null}
        </div>
    )
}
